import { PurchaseOrderReceiptDetail } from './../../acumatica/EntityServices/PurchaseOrder.service';
import { PurchaseOrderService } from '../../acumatica/EntityServices/PurchaseOrder.service';
import { PurchaseReceiptService } from '../../acumatica/EntityServices/PurchaseReceipt.service';
import { Component, OnInit, isDevMode } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-receiving-get-receipt',
  templateUrl: './receiving-get-receipt.component.html',
  styleUrls: ['./receiving-get-receipt.component.css']
})
export class ReceivingGetReceiptComponent implements OnInit {
  pageTitle = "Receiving";

  constructor(
    private router: Router,
    private purchaseOrders: PurchaseOrderService,
    private purchaseReceipts: PurchaseReceiptService,
  ) { }

  ngOnInit(): void { }

  // #region Search for Purchase Receipt by Purchase Order number
  purchaseReceiptSearchForm = new FormGroup({
    PONbr: new FormControl(null, Validators.required)
  });
  purchaseOrderFormError?: Error;
  searchReceipts: PurchaseOrderReceiptDetail[] = [];

  searchPurchaseReceipt(): void {
    const PONbr = this.purchaseReceiptSearchForm.get('PONbr')!.value;
    this.purchaseOrders.get('Normal', PONbr, {
      expand: "Receipts"
    }).subscribe({
      next: po => {
        this.searchReceipts = [];
        if (po.Status != 'Open') {
          this.purchaseOrderFormError = new Error("Purchase Order Status is \"" + po.Status + "\"");
          return;
        }

        this.searchReceipts = po.Receipts?.filter(receipt => receipt.Status == 'Balanced') || [];
        if (this.searchReceipts.length == 0) this.purchaseOrderFormError = new Error("No Open Balanced Receipts found on Purchase Order");
      },
      error: error => {
        this.purchaseOrderFormError = error;
      }
    })
  }
  // #endregion

  // #region Process open Receipt
  processPurchaseReceiptForm = new FormGroup({
    ReceiptNbr: new FormControl(
      isDevMode() ? localStorage.getItem('DEV-PO-RECEIPT-NBR') : null,
      Validators.required
    )
  })
  purchaseReceiptFormError: Error | null = null;

  processPurchaseReceipt(
    receiptNbr: string = this.processPurchaseReceiptForm.get('ReceiptNbr')!.value
  ): void {
    if (isDevMode()) localStorage.setItem('DEV-PO-RECEIPT-NBR', receiptNbr);
    this.router.navigate(['/receiving', receiptNbr]);
  }
  // #endregion
}
